var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.tabName,
            callback: function ($$v) {
              _vm.tabName = $$v
            },
            expression: "tabName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { lazy: true, label: "Customer list", name: "list" } },
            [_c("customer-table")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { lazy: true, label: "Skin status", name: "skin" } },
            [_c("skin-status")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { lazy: true, label: "Source", name: "source" } },
            [_c("customer-source")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { lazy: true, label: "Group", name: "group" } },
            [_c("customer-group")],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { lazy: true, label: "Rank", name: "rank" } },
            [_c("customer-rank")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }